<template>
  <v-expand-transition>
    <div v-show="count || privacyActive" class="ncrm-contacts__bulk-bar" :class="{ 'ncrm-contacts__bulk-bar--privacy-active': privacyActive }">
      <div v-if="count" class="ncrm-contacts__bulk-summary">
        {{ $t("ncrm.contacts.selection.selected", { count }) }}
      </div>
      <div class="ncrm-contacts__bulk-actions d-flex flex-wrap align-center ga-3">
        <v-btn v-if="count" color="primary" variant="tonal" :loading="loading" @click.stop="$emit('download')">
          <v-icon start size="16">mdi-download-outline</v-icon>
          {{ $t("ncrm.contacts.selection.downloadCsv") }}
        </v-btn>
        <NcrmCompanyConversionAction v-if="companyIds.length" :ids="companyIds" @converted="$emit('converted', $event)" />
        <NcrmPrivacyBulkPreviewAction :ids="ids" :subject-type="subjectType" :records="records" @active="privacyActive = $event" @sent="$emit('sent')" />
        <v-btn
          v-if="count" icon="mdi-close"
          size="small"
          variant="text"
          :aria-label="$t('ncrm.contacts.selection.clear')"
          @click.stop="$emit('clear')"
        />
      </div>
    </div>
  </v-expand-transition>
</template>
<script>
import NcrmCompanyConversionAction from "./NcrmCompanyConversionAction.vue";
import NcrmPrivacyBulkPreviewAction from "./NcrmPrivacyBulkPreviewAction.vue";
export default {
  name: "NcrmContactsBulkBar",
  components: { NcrmCompanyConversionAction, NcrmPrivacyBulkPreviewAction },
  props: {
    ids: { type: Array, default: () => [] },
    records: { type: Array, default: () => [] },
    subjectType: { type: String, default: "company" },
    companyIds: { type: Array, default: () => [] },
    count: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
  },
  emits: ["download", "clear", "converted", "sent"],
  data: () => ({ privacyActive: false }),
};
</script>
